import { useAliment, useAliments, useMedia } from "../../hooks";
import DataTable from "../../components/dataTables/DataTable";
import { Aliment } from "../../data-parsing/aliments/Aliment";
import { AddAlimentFormTemplate } from "../../data-parsing/aliments/FormTemplate";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { useState } from "react";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import {
  CreationForm,
  CreationFormTemplate,
} from "../../components/form/CreationForm";
import { ScrollableDragDropForm } from "../../components/form/DragDropForm";
import { TabbedContent } from "../../components/tabs/TabbedContent";

export function Aliments() {
  const [query, setQuery] = useState(null);
  const { aliments, createAliment, deleteAliment } = useAliments(query);
  const { createMedia } = useMedia("food/aliments/", "");
  let colDefs = buildColDefs(Aliment);
  const { putAliment } = useAliment();

  return (
    <LeftSideMenu active="aliments">
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="card-box card-tabs m-t-20">
                <h4 className="header-title m-t-0 m-b-30 pull-right">
                  ALIMENTOS
                </h4>
                <TabbedContent
                  removeContent={false}
                  tabHeaders={[
                    <button data-toggle="tab" aria-expanded="true">
                      <i className="fas fa-plus-circle"></i> NUEVO ALIMENTO
                    </button>,
                    <button
                      data-toggle="tab"
                      aria-expanded="false"
                      onClick={() => setQuery(0)}
                    >
                      <i className="far fa-eye"></i> LISTAR ALIMENTOS
                    </button>,
                  ]}
                >
                  <div className="fade in ">
                    <div className="row">
                      <CreationForm
                        createFunction={createAliment}
                        afterSubmit={createMedia}
                      >
                        <div className="col-md-5">
                          <div className="form-group">
                            <label>Imagen</label>
                            <ScrollableDragDropForm
                              fileTypes={["JPG", "PNG", "GIF"]}
                            />
                          </div>
                        </div>
                        <CreationFormTemplate
                          formTemplate={AddAlimentFormTemplate}
                          dataTemplate={Aliment}
                        />

                        <div className="col-sm-12">
                          <button className="btn btn-rounded btn-purple m-t-20 ml-10">
                            <i className="far fa-save"></i> Guardar Alimento
                          </button>
                        </div>
                      </CreationForm>
                    </div>
                  </div>

                  <div className="fade in">
                    <DataTable
                      colDefs={colDefs}
                      data={aliments}
                      dataId={"Aliments"}
                      resizable={true}
                      allowHiddenColumns={true}
                      scrollX={true}
                      className="table table-bordered panel-group"
                      editElement={putAliment}
                      deleteElement={deleteAliment}
                    />
                  </div>
                </TabbedContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
